import { teamMembers } from "../../../Components/TeamSlider";

const localProfileImagesByName = new Map([
  ["anjali kalwani", "/assets/team/anjali-kalwani.jpg"],
  ["ashish jangid", "/assets/team/ashish-jangid.jpg"],
  ["ayush dubey", "/assets/team/ayush-dubey.jpg"],
  ["bajrang mahawar", "/assets/team/bajrang-mahawar.jpg"],
  ["deepak dey", "/assets/team/deepak-dey.jpg"],
  ["himanshu vaswani", "/assets/team/himanshu-vaswani.jpg"],
  ["mayank moolchandani", "/assets/team/mayank-moolchandani.jpg"],
  ["muskan sharma", "/assets/team/muskan-sharma.jpg"],
  ["rahul jangid", "/assets/team/rahul-jangid.jpg"],
  ["saurabh kumar rai", "/assets/team/saurabh-kumar-rai.jpg"],
  ["tim ball", "/assets/team/tim-ball.jpg"],
  ["yuvraj singh gour", "/assets/team/yuvraj-singh-gour.jpg"],
]);

const teamProfileImagesByName = new Map(
  teamMembers.map((member) => [String(member.name || "").trim().toLowerCase(), member.image])
);

const profileImageFields = [
  "profileImageUrl",
  "profilePhotoUrl",
  "profileImage",
  "picture",
  "imageUrl",
  "photoUrl",
  "Profile_Image_URL__c",
];

export const normalizeProfileName = (value = "") =>
  String(value).trim().toLowerCase().replace(/\s+/g, " ");

export const getProfileImageCandidates = (person = {}) => {
  const profileName = normalizeProfileName(person.name);
  const candidates = [
    ...profileImageFields.map((field) => person[field]),
    localProfileImagesByName.get(profileName),
    teamProfileImagesByName.get(profileName),
  ];

  return [...new Set(candidates.map((value) => String(value || "").trim()).filter(Boolean))];
};
